import { z } from 'zod';

export const schema = z.object({
  province: z.string().min(1, { message: 'Required' }),
  address: z.string().min(1, { message: 'Required' }),
  city: z.string().min(1, { message: 'Required' }),
  postal_code: z.string().min(1, { message: 'Required' }),
  country: z.string().min(1, { message: 'Required' })
});